/**
 * The type of redux action which stores a specific JSON Web Token (JWT) into
 * the redux store.
 *
 * {
 *     type: SET_JWT,
 *     jwt: string
 * }.
 */
export const SET_JWT = 'SET_JWT';

/**
 * The type of redux action which store the meeting info into
 * the redux store.
 *
 * {
 *     type: SET_MEETING_INFO,
 *     mtinfo: Object
 * }.
 */
export const SET_MEETING_INFO = 'SET_MEETING_INFO';

/**
 * Set Access token in the meeting basedo n the jwt.
 *  {
 *     type: SET_ACCES_TOKEN,
 *     accTkn: String
 * }.
*/
export const SET_ACCESS_TOKEN = 'SET_ACCESS_TOKEN';

/**
 * Set Meeting Features and settings.
 *  {
 *     type: SET_USER_SETTING,
 *     accTkn: Object
 * }.
*/
export const SET_USER_SETTING = 'SET_USER_SETTING';

/**
 * Set USER ROLE IN THE CONFERENCE
 * {
 *     type: SET_USER_ROLE,
 *     accTkn: Object
 * }.
*/
export const SET_USER_ROLE = 'SET_USER_ROLE';


/**
 * Set JWt without moderator in conferences.
 * {
 *     type: JWT_STORAGE,
 *     accTkn: Object
 * }.
*/
export const JWT_STORAGE = 'JWT_STORAGE';

/**
 * Start time for the meeting.
 * {
 *     type: MEETING_TIMING,
 *     mtTime: Object
 * }.
*/
export const MEETING_TIMING = 'MEETING_TIMING';

/**
 * Start time for the meeting.
 * {
 *     type: MEETING_TIMING,
 *     mtTime: Object
 * }.
*/
export const SET_RENDER_CONTENT = 'SET_RENDER_CONTENT';
